import { LOCAL_STORAGE_KEYS } from '@constants/storage';

import { DismissedComponentsStorage } from '../types';
import { getOrgSegment, ScopedStorage } from './storageSegments';

const store = new ScopedStorage<DismissedComponentsStorage>(
  LOCAL_STORAGE_KEYS.DISMISSED_DYNAMIC_COMPONENTS,
  {}
);

export const getDismissedStorage = (): DismissedComponentsStorage =>
  store.read(getOrgSegment());

export const isDismissed = (componentType: string, id: string): boolean => {
  const storage = getDismissedStorage();
  return (storage[componentType] ?? []).includes(id);
};

export const dismiss = (componentType: string, id: string): void => {
  const org = getOrgSegment();
  const current = store.read(org);
  const existing = current[componentType] ?? [];
  if (!existing.includes(id)) {
    store.write(org, {
      ...current,
      [componentType]: [...existing, id]
    });
  }
};
